import create from "zustand";

const useLiveAvatarStore = create((set) => ({
  avatar: null,
  avatarMediaStream: null,
  isAvatarSpeakingRef: false,
  currentPlaybackMsgRef: null,
  interruptRef: false,
  clearCaptionRef: false,
  isAvatarLoading: true,
  isAvatarStreamAvailable: false,
  avatarEventsStream: null,
  avatarEventsController: null,
  avatarEventsReader: null,
  avatarSession: null,
  liveAvatarSessionId: null,
  sessionError: null,
  opener: sessionStorage.getItem("opener"),
  sysPrompt: sessionStorage.getItem("sysPrompt"),

  setSysPrompt: (data) =>
    set(() => {
      console.log(`[LiveAvatarStore] Setting system prompt:`, {
        hasPrompt: !!data,
        promptLength: data?.length || 0,
      });
      sessionStorage.setItem("sysPrompt", data);
      return { sysPrompt: data };
    }),

  setOpener: (data) =>
    set(() => {
      console.log(`[LiveAvatarStore] Setting opener:`, {
        hasOpener: !!data,
        openerLength: data?.length || 0,
      });
      sessionStorage.setItem("opener", data);
      return { opener: data };
    }),

  setAvatarSession: (data) => {
    console.log(`[LiveAvatarStore] Setting avatar session:`, {
      hasSession: !!data,
    });
    return set({ avatarSession: data });
  },

  setAvatar: (data) => {
    console.log(`[LiveAvatarStore] Setting avatar:`, { hasAvatar: !!data });
    return set({ avatar: data });
  },

  setLiveAvatarSessionId: (data) => {
    console.log(`[LiveAvatarStore] Setting LiveAvatar session id:`, {
      sessionId: data,
    });
    return set({ liveAvatarSessionId: data });
  },

  setSessionError: (data) => {
    console.log(`[LiveAvatarStore] Setting session error:`, {
      hasError: !!data,
    });
    return set({ sessionError: data });
  },

  setIsAvatarSpeaking: (data) => {
    console.log(`[LiveAvatarStore] Setting avatar speaking status:`, {
      isSpeaking: data,
    });
    return set({ isAvatarSpeakingRef: data });
  },

  setIsAvatarStreamAvailable: (data) => {
    console.log(`[LiveAvatarStore] Setting avatar stream availability:`, {
      isAvailable: data,
    });
    return set({ isAvatarStreamAvailable: data });
  },

  setCurrentPlaybackMsg: (data) => {
    console.log(`[LiveAvatarStore] Setting current playback message:`, {
      hasMessage: !!data,
    });
    return set({ currentPlaybackMsgRef: data });
  },

  setInterrupt: (data) => {
    console.log(`[LiveAvatarStore] Setting interrupt status:`, {
      shouldInterrupt: data,
    });
    return set({ interruptRef: data });
  },

  setClearCaption: (data) => {
    console.log(`[LiveAvatarStore] Setting clear caption status:`, {
      shouldClear: data,
    });
    return set({ clearCaptionRef: data });
  },

  setAvatarMediaStream: (data) => {
    console.log(`[LiveAvatarStore] Setting avatar media stream:`, {
      hasStream: !!data,
    });
    return set({ avatarMediaStream: data });
  },

  setIsAvatarLoading: (data) => {
    console.log(`[LiveAvatarStore] Setting avatar loading status:`, {
      isLoading: data,
    });
    return set({ isAvatarLoading: data });
  },

  setAvatarEventsStream: (data) => {
    console.log(`[LiveAvatarStore] Setting avatar events stream:`, {
      hasStream: !!data,
    });
    return set({ avatarEventsStream: data });
  },

  setAvatarEventsController: (data) => {
    console.log(`[LiveAvatarStore] Setting avatar events controller:`, {
      hasController: !!data,
    });
    return set({ avatarEventsController: data });
  },

  setAvatarEventsReader: (data) => {
    console.log(`[LiveAvatarStore] Setting avatar events reader:`, {
      hasReader: !!data,
    });
    return set({ avatarEventsReader: data });
  },
}));

export default useLiveAvatarStore;
